module.exports = __webpack_public_path__ + "assets/img/side-navigation-reservation-active-ffaf2779.png";